export enum CURRENT_ENV_NAMES {
  UAT = 'UAT',
  PROD = 'PROD',
}

export enum GRANT_TYPE_NAMES {
  AUTHORIZATION_CODE = 'authorization_code',
  REFRESH_TOKEN = 'refresh_token',
}

export enum GLOBAL_LISTENER_EVENTS {
  GLOBAL_LOGIN = 'global_login',
  GLOBAL_LOGOUT = 'global_logout',
}

export enum LOGIN_INITIATE_TYPES_NAMES {
  NOTIF_BUTTON = 'notifButton',
  FROM_HEADER = 'FromHeader',
  OPEN = 'open',
  NONE = 'none',
}

export type CURRENT_ENV = CURRENT_ENV_NAMES.UAT | CURRENT_ENV_NAMES.PROD;
export type GRANT_TYPE = GRANT_TYPE_NAMES.AUTHORIZATION_CODE | GRANT_TYPE_NAMES.REFRESH_TOKEN;
export type LOGIN_INITIATE_TYPES =
  | LOGIN_INITIATE_TYPES_NAMES.FROM_HEADER
  | LOGIN_INITIATE_TYPES_NAMES.NOTIF_BUTTON
  | LOGIN_INITIATE_TYPES_NAMES.OPEN
  | LOGIN_INITIATE_TYPES_NAMES.NONE;
